/**
 * @file DevicePreview.tsx
 * @module DevicePreview
 * @description
 *   Mount point for the NoolpaavaiReact DeviceList integration.
 *   Rendered by PreviewSection when activeState === FireTVPreviewState.DEVICE_PREVIEW.
 */

import { useCallback } from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';
import { RDPProvider, DeviceList, DeviceScreen } from '@amzn/noolpaavai-react';
import { useAuthentication } from 'src/contexts/AuthenticationContext';
import { getUserAlias } from 'src/components/authentication/AuthenticationUtils';
import { getRdpStage } from 'src/configs/rdpConfiguration';
import { DevicePreviewErrorBoundary } from './DevicePreviewErrorBoundary';

export const DevicePreview = () => {
  const { user } = useAuthentication();

  const getAuthToken = useCallback(
    async () => (await fetchAuthSession()).tokens?.idToken?.toString() ?? '',
    [],
  );

  if (!user) return null;

  return (
    <DevicePreviewErrorBoundary>
      <RDPProvider
        config={{
          stage: getRdpStage(),
          getAuthToken,
          userId: getUserAlias(user),
        }}
      >
        <DeviceList />
        <DeviceScreen />
      </RDPProvider>
    </DevicePreviewErrorBoundary>
  );
};
